import { downloadTableAsExcel } from './excel-export.util';

export const B2B_EXPORT_PAGE_SIZE = 5000;

export interface B2bExportColumn {
  titulo: string;
  label: string;
  formatter?: (value: any, row?: any) => string;
}

export function rowsFromPagedResponse(response: any): any[] {
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.Data)) return response.Data;
  if (Array.isArray(response?.items)) return response.items;
  if (Array.isArray(response?.Items)) return response.Items;
  if (Array.isArray(response)) return response;
  return [];
}

export function exportB2bTableToExcel(
  fileName: string,
  columns: B2bExportColumn[],
  rows: any[],
  sheetName = 'Dados'
): void {
  const headers = columns.map(c => c.titulo);
  const data = (rows || []).map(item =>
    columns.map(c => {
      const val = item?.[c.label];
      const formatted = c.formatter ? c.formatter(val, item) : val;
      if (formatted == null || formatted === '') return '';
      return formatted as string | number;
    })
  );
  downloadTableAsExcel(fileName, headers, data, [], { sheetName });
}
